import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "components/ui/Select";
import { usePrintCvletter } from "http-hooks/cvletter/useCvletter";
import { getDocumentViewerRoute } from "utils/documentUrlHelper";

const printOptions = [
  { value: "with_recon", label: "With Recon" },
  { value: "without_recon", label: "Without Recon" }
];

export default function PrintCvletter({ refid, onClose }) {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(printOptions[0]);
  const { mutateAsync: printCvletter, isPending } = usePrintCvletter();

  const handlePrint = async () => {
    try {
      const withRecon = selectedOption.value === "with_recon";
      
      console.log("Print Covering Letter:", {
        refid: refid,
        printType: selectedOption.value,
        withRecon: withRecon
      });
      
      const result = await printCvletter({ id: refid, withRecon });

      if (result.htmlUrl) {
        const baseUrl = process.env.REACT_APP_MAIN_BASE_URL || "";
        const htmlUrl = `${baseUrl}${result.htmlUrl}`;

        const route = getDocumentViewerRoute(refid, {
          htmlUrl,
          pdfUrl: "",
          documentNumber: refid,
          documentType: "Covering Letter",
        });

        onClose();
        navigate(route);
      }
    } catch (error) {
      console.error("Error printing covering letter:", error);
      // Error toast is already handled in the service layer
    }
  };

  return (
    <div>
      <div className="sm:flex sm:items-start">
        <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
          <h3 className="text-base font-semibold leading-6 text-gray-900 mb-4">
            Print Covering Letter
          </h3>
          
          <div className="mt-4">
            <p className="text-sm text-gray-600 mb-4">
              Reference ID: <span className="font-semibold">{refid}</span>
            </p>
            
            <Select
              label="Print Type"
              options={printOptions}
              value={selectedOption}
              onChange={setSelectedOption}
              placeholder="Select print type"
              isRequired={true}
            />
          </div>
        </div>
      </div>
      
      <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
        <button
          type="button"
          onClick={handlePrint}
          disabled={isPending}
          className="inline-flex w-full justify-center rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isPending ? "Generating..." : "Proceed"}
        </button>
        <button
          type="button"
          onClick={onClose}
          disabled={isPending}
          className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

